import { Injectable } from "@angular/core";
import * as html2pdf from 'html2pdf.js';

@Injectable({
    providedIn: "root",
})

export class ExportService {
    exportAsPdf(id, opt) {
        let element = document.getElementById(id);
        html2pdf().from(element).set(opt).save();
    }
}